import { render, staticRenderFns } from "./resgatar.vue?vue&type=template&id=0cb21c9b&"
import script from "./resgatar.vue?vue&type=script&lang=js&"
export * from "./resgatar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0cb21c9b')) {
      api.createRecord('0cb21c9b', component.options)
    } else {
      api.reload('0cb21c9b', component.options)
    }
    module.hot.accept("./resgatar.vue?vue&type=template&id=0cb21c9b&", function () {
      api.rerender('0cb21c9b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/icons/svg/resgatar.vue"
export default component.exports